import axios from 'axios';

let prefix = "/pet"

const PetApi = {
	
	listPet(payload){
		return axios.get( prefix + "/list", {params: payload})
	},
	listPetObtainRef(payload){
		return axios.get( prefix + "/obtain-ref", {params: payload})
	},
	getPet(payload){
		return axios.get( prefix + "/get", {params: payload})
	},
	createPet(payload){
		return axios.post( prefix + "/create", payload)
	},

	updatePet(payload){
		return axios.post( prefix + "/update", payload)
	},

	uploadPetFile(payload, onUploadProgress = {} ){
		return axios.post(prefix + "/upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},

	bulkUploadPetFile(payload, onUploadProgress = {} ){
		return axios.post(prefix + "/bulk-upload", payload,{
			headers: { 'Content-Type': 'multipart/form-data'},
			onUploadProgress
		})
	},

}

export default PetApi;